const fr = {
  herosection: "Votre plateforme d'assurance numérique",

  addBeneficiary: " Plans épargnes",
  declaration: "Déclaration de sinistre",
  subscriptionNow: "Inscrivez vous !!",
  sinistre: "Sinstre",
  incorrectCredentials: "Identifiants incorrects",
  insuranceID: "Numéro Téléphone",
  VERIFY_OTP: "VERIFICATION OTP",
  techCarePIN: "PIN TechCare",
  enterInsuranceID: "Entrer votre numero de téléphone",
  enterPIN: "Entrez le PIN",
  userLoggedIn: "Utilisateur connecté avec succès",
  signUp: "S'inscrire",
  formInvalid:
    "Formulaire invalide veuillez vérifier les informations entrées.",
  verifying: "Verification",
  verifyAccount: "Vérifier mon compte",
  addSubAccountDevice:
    "Merci de remplir ce formulaire pour vous inscrire à TECHCARE 237 et profiter pleinement de nos services.",
  successfulInitiateSubsription:
    "L'initiation de votre souscription a été executé avec success",
  failedInitiateSubsription:
    "L'initiation de votre souscription a echoué veuillez reesayer plus tard",
  invalidCredentials: "Identifiants invalides",
  loginError: "Une erreur est survenue lors de la connexion",
  techcare_subtitle: "Votre plateforme d'assurance numérique",
  collaboration_text:
    "Fruit de la collaboration entre Credixcam et SanlamAllianz, Couvert par l’assureur SanlamAllianz",
  successEligile:
    "Félicitations ! Votre épargne vous permet de bénéficier d'une assurance. Faites votre choix !",
  pendingAssue:
    "Votre demande d'ahésion a votre package d'assurance est en cours de validation",
  allStatus:"Tous les statuts",
  insuredSuccess:
    "Vous avez deja un compte souscrit a un package d'assurance vous ne pouvez plus souscrire sur un autre compte !",
  beneficieInsurance:
    "Vous bénéficiez de notre couverture assurance, Merci pour votre confiance !",
  nosPackages: "Nos Packages d'Assurance",
  transactionButon: "Historique des Transactions",
  declarationButton: "Consulter mes declarations",
  viewassue: "Consulter mon assuré",
  insufficientfound:
    "Epargner d'avantage pour bénéficier de notre couverture assurance. !",
  infoAccount: "Informations du Compte",
  titulaireAccount: "Nom du Titulaire",
  amountSave: "Montant épargné",
  amountInterest: "Interet",
  typeEpargne:"(Epargne Libre)",
   titleEpargne1: "(Epargne avec Objectif)",
  amountCible: "Montant cible",
  dateObjectif: "Date objectif",
  balance:"Balance",
  amountFrequency: "Fréquence de cotisation",
  progression: "Progrès de l'objectif",
  thermeetcondition: "Nos Thermes et Condition",
  readMore: "En savoir plus",
  confirmPackage:
    "Ce package vous permet de bénéficier d'une assurance maladie de",
  confirmPackage2: "et décés de",
  assueButton: "Consulter mon assuré",
  transactionTitle: "Historique des Transactions",
  lastTransaction: "Dernières Transactions",
  notFrequence: "Aucune Fréquence",
  notObjectif: "Aucun Objectif",
  confirmButton: "Confirmer",
  confirmPackage3:
    "Une fois choisi, ce plan ne peut être modifié jusqu'à la fin de sa validité.",
  aboutUs: "À propos de nous",
  aboutTechCare: "Nous fournissons des services d'assurance professionnels.",
  aboutTechCareDesc:
    "Nous offrons des solutions d'assurance complètes adaptées à vos besoins spécifiques. Notre équipe d'experts est dédiée à vous offrir la meilleure couverture à des tarifs compétitifs. Faites-nous confiance pour protéger ce qui compte le plus pour vous grâce à nos services fiables et professionnels.",
  ourServices: "Nos services",
  hospitalizationInsurance: "Assurance hospitalisation",
  hospitalizationInsuranceDesc:
    "Notre assurance hospitalisation vous garantit une couverture pour tout séjour imprévu à l'hôpital. Avec des plans conçus pour répondre à vos besoins, vous pouvez avoir l'esprit tranquille en sachant que vos frais médicaux sont pris en charge.",
  disabilityInsurance: "Assurance invalidité",
  disabilityInsuranceDesc:
    "Protégez vos revenus avec notre assurance invalidité. En cas d'invalidité vous empêchant de travailler, notre police fournit un soutien financier pour vous aider à maintenir votre niveau de vie et à couvrir les dépenses essentielles.",
  deathInsurance: "Assurance décès",
  deathInsuranceDesc:
    "Notre assurance décès offre une sécurité financière à vos proches en cas de décès. Assurez-vous que votre famille et vos proches sont protégée(s) , en sécurité et que leur avenir est sécurisé grâce à nos plans d'assurance fiables.",
  viewMore: "Voir plus",
  whatClientsSay: "Ce que disent nos clients",
  contactUs: "Nous contacter",
  phoneNumber: "Numéro de téléphone",
  message: "Message",
  send: "ENVOYER",
  clientTestimonials: "Témoignages des clients",
  clientFeedback1:
    "“Cette entreprise a fourni un service et un soutien excellents lors de mon processus de réclamation d'assurance. Le personnel était attentif et m'a aidé à chaque étape.”",
  clientFeedback2:
    "“Je suis extrêmement satisfait de la police d'assurance que j'ai obtenue. Elle était abordable et complète. Le service client était exceptionnel.”",
  clientFeedback3:
    "“Leur couverture d'assurance est inégalée. Je suis client depuis des années et j'ai toujours été impressionné par leur professionnalisme et leur efficacité.”",
  clientFeedback4:
    "“Je recommande vivement cette compagnie d'assurance. Ils offrent d'excellentes polices et leur équipe de support est très réactive et serviable.”",
  carouselPrev: "Précédent",
  carouselNext: "Suivant",
  fillAllFields: "Veuillez vérifier tous les champs obligatoires et réessayer",
  UserProfile: "Profil de l`utilisateur",
  ClientDetails: "Information",
  Bulletin_dadhesion: "Profil",
  assuredProfession: "Entrer votre professsion",
  assuredAdresse: "Entrer votre adresse",
  assuredNui: "Entrer votre numéro d'identification unique",
  selectNationality: "Selectionner votre nationalité",
  UploadPhoto: "Télécharger la Photo",
  subscribeNow: "SOUSCRIVEZ MAINTENANT",
  enterPassword: "Entrer votre mot de passe",
  confirmPassword: "Confirmer votre mot de passe",
  password: "Mot de passe",
  // completeSubscription:
  clientInfoFetched: "Informations client récupérées avec succès",
  errorFindingClientInfo: "Erreur lors de la recherche des informations client",
  clientUpdated: "Informations client mises à jour avec succès",
  editingFailed: "Échec de l'édition",
  errorUpdatingClient: "Erreur de mise à jour des informations client",
  completionInProgress: "Achèvement en cours",
  subscriptionCompleted: "Abonnement complété avec succès",
  subscription: "SOUSCRIPTION",
  subscriptionFailed: "Échec de l'achèvement de l'abonnement",
  beneficiaryAdded: "Bénéficiaire ajouté avec succès",
  checkDetailsAndTryAgain: "Vérifiez les détails et réessayez",
  failed: "Échec",
  loadingClientInfo: "Chargement des informations client",
  addBeneficiaryAdvice:
    "Si vous avez un bénéficiaire, veuillez ajouter ses coordonnées.",
  enterRequiredInformation: "Informations requises",
  insuranceId: "ID d'assurance",
  insuranceIdPlaceholder: "Entrez l'ID d'assurance",
  namePlaceholder: "Entrez le nom",
  nationality: "Nationalité",
  nationalityPlaceholder: "Entrez la nationalité",
  phoneNumberPlaceholder: "Entrez le numéro de téléphone",
  dateOfBirth: "Date de naissance",
  dateOfBirthPlaceholder: "Sélectionner la date de naissance",
  residence: "Résidence",
  residencePlaceholder: "Entrez la résidence",
  nationalId: "Numero CNI",
  nationalIdPlaceholder: "Entrez l'ID national",
  cniIssueDate: "Date d'émission de la CNI",
  cniExpiryDate: "Date d'expiration de la CNI",
  cniIssueDatePlaceholder: "Sélectionner la date d'émission de la CNI",
  cniExpiryDatePlaceholder: "Sélectionner la date d'expiration de la CNI",
  cniPlaceOfIssue: "Lieu d'émission de la CNI",
  assureinfo:
    "Remplissez les informations de votre bénéficiare hospitalisation",
  cniPlaceOfIssuePlaceholder: "Entrez le lieu d'émission de la CNI",
  gender: "Genre",
  selectGender: "Sélectionner le genre",
  male: "Homme",
  female: "Femme",
  other: "Autre",
  email: "Email",
  emailPlaceholder: "Entrez l'email",
  maritalStatus: "État civil",
  selectStatus: "Sélectionner l'état civil",
  single: "Célibataire",
  married: "Marié",
  divorced: "Divorcé",
  widowed: "Veuf",
  update: "Mettre à jour",
  complete: "Compléter la Subscription",
  relationship: "Relation",
  relationshipPlaceholder: "Entrez la relation",
  occupation: "Profession",
  occupationPlaceholder: "Entrer la profession",
  address: "Adresse",
  addressPlaceholder: "Entrer l'adresse",
  politicallyExposed: "Personne politiquement exposée",
  selectOption: "Sélectionnez une option",
  yes: "Oui",
  no: "Non",
  close: "Fermer",
  saveChanges: "Sauvegarder les modifications",
  guardianName: "Nom du tuteur",
  guardianNamePlaceholder: "Entrez le nom du tuteur",
  guardianRelationship: "Relation avec le tuteur",
  guardianRelationshipPlaceholder: "Entrez la relation avec le tuteur",
  guardianPhoneNumber: "Numéro de téléphone du tuteur",
  guardianPhoneNumberPlaceholder: "Entrez le numéro de téléphone du tuteur",
  guardianDateOfBirth: "Date de naissance du tuteur",
  guardianInfo:
    "Le bénéficiaire est mineur, veuillez entrer les informations du tuteur",
  invalidDateGuardian:
    "Date invalide, le tuteur ne peut pas avoir moins de 21 ans ",
  invalidDateGuardian21:
    "Date invalide, le tuteur ne peut pas avoir moins de 21 ans",
  PoliceTelephone: "Numéro de téléphone de la police",
  updateBeneficiary: "Mettre à jour",
  father: "Père",
  mother: "Mère",
  brother: "Frère",
  sister: "Sœur",
  child: "Enfant",
  spouse: "conjoint(e)",
  userInfo: "Informations Utilisateur",
  DocumentStatus: "Statut des documents",
  lieuNaissance: "Lieu de naissance",
  personnelInfo: "Informations personnelles",
  hospiInfo: "Informations du Bénéficiaire Hospitalisation",
  // Beneficiary

  beneficiaryName: "Nom du bénéficiaire",
  enterName: "Entrez le nom",
  relationshipWithBeneficiary: "Relation avec le bénéficiaire",
  selectRelationship: "Sélectionner la relation",
  beneficiaryTelephoneNumber: "Numéro de téléphone du bénéficiaire",
  enterTelephoneNumber: "Entrer le numéro de téléphone",
  beneficiaryDateOfBirth: "Date de naissance du bénéficiaire",
  noAvailableBeneficiary: "Aucun bénéficiaire disponible",
  clientID: "ID Client",
  pleaseWait: "Veuillez patienter...",
  Back: "Précédent",
  Benficiaryaddedsuccessfully:
    "Votre fiche d'inscription  a été envoyé avec succès",
  days: "Jours",
  Consulter: "Consulter",
  titleConnect: "CONNECTEZ-VOUS",
  connexionDetail: "Entrer vos identifiants de connexion!",
  sousTitleEpargne: "Plans Epargnes",
  titleEpargne: "Mes Comptes Epargne",
  contact: "Nos Contacts",
  backAccount: "Retour au compte",
  amount: "Montant",
  Statut: "Statut",
  Envoyer: "Envoyer",
  ifAffiled: "Le numéro est déjà affilié a un package d'assurance",
  Benficiaryupdatedsuccessfully: "Bénéficiaire mis à jour avec succès.",
  Profil: "Mon compte",
  birthDay: "Date de naissance",
  clientNotFound: "Échec de la récupération du client",
  requiredField: "Ce champ est obligatoire",
  minimumCharacters: "Ce champ doit comporter au moins 2 caractères.",
  maximumCharacters: "Ce champ ne doit pas comporter plus de 50 caractères",
  invalidEmail: "Veuillez saisir une adresse électronique valide.",
  phoneNumberLength: "Le numéro de téléphone doit comporter 12 chiffres.",
  enterIdIssueDate: "Date de délivrance de la CNI",
  idExpiryDate: "Date d'expiration de la CNI",
  idPlaceOfIssue: "Lieu de délivrance",
  enterEmail: "exemple@gmail.com",
  enterIdPlaceOfIssue: "Entrer le lieu de délivrance de la CNI  ",
  enterIdExpiryDate: "Entrer la date d'expiration de la CNI",
  idIssueDate: "Date de délivrance",
  minimumAge: "Vous devez être âgé d'au moins 18 ans",
  maximumAge: "Vous devez avoir moins de 65 ans.",
  enterFullName: "Entrer votre nom et prenom",
  fullName: "Nom et Prenom",
  parentInsuranceId: "Parent insurance ID",
  english: "ANGLAIS",
  french: "FRANCAIS",
  idnumber: "Numéro de votre CNI",
  cni: "Numero CNI",
  identitySection: "Pièce d'identité",
  enterPhoneNumber: "Entrer votre numéro de téléphone ",
  selectLanguage: "Selectionner votre langue",
  enterParentInsuranceId: "Entrer insurance ID de votre parent",

  // NavBar
  home: "Accueil",
  about: "À propos",
  contact: "Contact",
  faq: "FAQ",
  signIn: "SE CONNECTER",
  signOut: "SE DÉCONNECTER",
  viewuserDetails: "Voir les détails de l'utilisateur",
  nouser: "Aucun utilisateur connecté",

  // Footer
  joinNewsletter:
    "Rejoignez la newsletter Tech-Care pour recevoir nos meilleures offres d'assurance",
  unsubscribeAnytime: "Vous pouvez vous désabonner à tout moment.",
  yourEmail: "Votre e-mail",
  subscribe: "S'abonner",

  // Clamims Declaration

  Step1ConfirmInsuranceCode: "Étape 1 : Confirmez le code d'assurance",
  Step2Declaration: "Étape 2 : Déclaration",
  Step3UploadClientNationalIDCard:
    "Étape 3 : Téléchargez la carte d'identité nationale du client",
  Step4UploadOtherClientDocuments: "Étape 4 : Téléchargez les Documents client",
  InsuranceCode: "Code d'assurance",
  SelectyourClaim: "Veuillez selectionner le type de sinistre",
  SelectClaim: "Selectionner un sinistre",
  DOCUMENTSREQUIRED: "DOCUMENTS REQUIS",
  UploadFrontViewofIDCard: "Télécharger la vue de face de la carte d'identité",
  UploadBackViewofIDCard: "Télécharger la vue arrière de la carte d'identité",
  UploadOtherClientDocuments: "Télécharger d'autres documents client",
  Thankyou: "Merci!",
  Thanksforconfirmingyoursubscription:
    "Merci d'avoir confirmé votre abonnement! Nous espérons que vous vous amuserez en utilisant notre plateforme. Si vous avez besoin d'aide, n'hésitez pas à nous contacter par email à support@credixcm.com.",
  BacktoHomePage: "Retour à la page d'accueil",

  NoClaimavailable: "Aucun Sinistres disponible",
  SelectDoc: "Sélectionner un document",
  NoDocumentavailable: "Aucun document disponible",
  NoAccountAvailable: "Aucun compte pour vous assurer",
  selectYouAccount: "Entrez le numéro de contrat d'assurance",
  failedToFetchClientDetails:
    "Vous n'etes pas eligible a un package d'assurance épargner d'avantage pour votre premiere connexion.",
  SelectAccount: "Sélectionnez un compte assurance",
  invalidOtp: "Votre code de vérification est incorrect.",
  beneficiaryInfo:
    "Veuillez vérifier et compléter vos informations en tant q'assuré(e), c'est-à-dire la personne qui bénéficiera de la couverture en cas d'hospitalisation.Une fois cette étape terminée, vous pourrez ajouter les informations de votre bénéficiaire en cas de décès, en cliquant sur le bouton  BénéficiaireMerci de veiller à ce que les informations fournies soient exactes et à jour.",
  Previous: "Précédent",
  Next: "Suivant",
  Complete: "Compléter",
  FrontViewID: "Vue de face",
  BackViewID: "Vue de dos",
  UploadId: "Télécharger",
  UploadDoc: "Télécharger",
  ViewClaims: "Voir mon sinistre",
  declaredDate: "Date déclaration",
  dateValidation: "Date de validation",
  conditionText:
    "J'accepte l'utilisation de mes données selon les termes et conditions TechCare237",
  passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
  youMustAcceptTerms:
    "Vous devez accepter l'utilisation de vos données personnelles pour finaliser votre inscription.",
  IDCardPhotoUploadedSuccessfully:
    "Photo de la carte d'identité téléchargée avec succès",
  FailedIDCardPhotoUploadTryAgain:
    "Échec du téléchargement de la photo de la carte d'identité !!! Réessayez",
  DocumentUploadedSuccessfully: "Document téléchargé avec succès",
  FailedDocumentTryAgain: "Échec du document !!! Réessayez",

  ineligibleAccess: "Accès inéligible",
  notEligibleMessage:
    "Vous n'êtes pas encore éligible pour accéder au service. Veuillez d'abord enregistrer pour devenir éligible.",
  goBackToHomepage: "Retour à la page d'accueil",
  failedToCheckStatus: "Aucun Status disponible",
  underageAge: "Vous devez avoir plus de 18 ans.",
  claims: "Sinistres",
  completeSubscription: "Profil",
  subscription: "Inscription",
  claimType: "TYPE DE SINISTRES",
  document: "DOCUMENT",
  comment: "COMMENTAIRE",
  status: "STATUT",
  listOfClaims: "Sinistres",
  termeEtConditions: "Termes et Conditions",
  termeEtConditionsDes: "TERMES ET CONDITIONS",
  condition: "Nos Termes Et Conditions",
  search: "Recherche",
  insuredInformation:
    "Remplissez les informations du bénéficiare en cas de décés",
  next: "Suivant",
  titreInscription: "Rejoignez la communauté TechCare",
  sousTitreInscription:
    "En épargnant régulièrement, vous bénéficiez d'une assurance qui vous protège en cas d'hospitalisation ou de décès.",
  inputIdInsurance: "Entrez le numero de contrat du plan assurance",
  completeYourInformationToAccessInsurance:
    "Veuillez compléter les informations de votre profil pour accéder aux fonctionnalités et services d'assurance.",
  hideInsured: "Beneficiare Déces",
  assue: "Souscription à l'assurance",
  epargnes: "Nos Offres d’Assurance",
  enterIdPlaceOfBirth: "Entrer votre lieu de naissance",
  assuredPlaceOfBirth: "Lieu de Naissance",
  addAssure: "Ajouter Un Assuré",
  failedToFindDocumentStatus:
    "Échec de la recherche du statut du document !!! Réessayez plus tard",
  mustBeAtLeast18: "vos avez moins de 18 ans.",
  personalInformationMessage: "Remplisser vos informations.",
  identificationMessage: "Remplisser vos informations d'identification.",
  securityInformationMessage:
    "Sécuriser votre compte avec un mot de passe a 5 chiffres.",
  information: "Informations Personnelles",
  selectedRowsDeleted:
    "Les lignes sélectionnées ont été supprimées avec succès",
  declareClaims: "Déclarer des Sinistres",
  uploadEachDocumentIndividually: "Téléchargez chaque document un par un",
  fileUploadGuidance:
    "Types de fichiers acceptables : PDF, JPG, PNG. Taille maximale du fichier : 5 Mo par fichier.",
  FileSizeExceeds5MB: "La taille du fichier dépasse la limite de 5 Mo.",
  OnlyImageAndTextFilesAllowed:
    "Seuls les fichiers image et texte sont autorisés",
  PleaseSelectAFile: "Veuillez sélectionner un fichier à télécharger.",
  SelectAccountForDeclaration: "Selectionner le compte pour la déclaration",
  thankYouHeading: "Merci !",
  pleaseSubscribe:
    "Nous vous remercions de votre demande concernant la déclaration d'un sinistre. Cependant, d'après nos dossiers, il apparaît que vous n'avez pas souscrit de plan d'assurance auprès de nous. Malheureusement, les demandes d'indemnisation ne peuvent être traitées que pour les clients ayant souscrit un régime d'assurance actif.",
  thankYouMessage:
    "Merci d'avoir soumis tous les documents nécessaires ! Nous espérons que vous apprécierez utiliser notre plateforme. Si vous avez besoin de soutien, n'hésitez pas à nous envoyer un email à helpdeskcredi",
  // About Page

  About: "À propos",
  AboutCredix: "Credixcam.sa",
  editInformation: "Modifier les informations",
  updateInformation: "Mettre à jour les informations",
  platinuimDescription:
    "Couverture d'hospitalisation annuelle : 300 000 FCFA \n Indemnité journalière d'hospitalisation :  10 000 FCFA \n  Couverture décès  : 500 000 FCFA \n  Le Pack Platinium vous permet de bénéficier d'une assurance vie à partir d'une épargne mensuelle minimal de 0 FCFA.",
  goldDescription:
    "Couverture d'hospitalisation annuelle : 225 000 FCFA \n Indemnité journalière d'hospitalisation :  7 500 FCFA \n  Couverture de décès  : 375 000 FCFA \n Le Pack Gold vous permet de bénéficier d'une assurance vie à partir d'une épargne mensuelle minimal de 0 FCFA.",
  silverDescription:
    "Couverture d'hospitalisation annuelle : 120 000  FCFA \n Indemnité journalière d'hospitalisation  : 4 000 FCFA \n Couverture de décès  : 200 000 FCFA \n Le Pack SILVER vous permet de bénéficier d'une assurance vie à partir d'une épargne mensuelle minimal de 0 FCFA",
  bronzeDescription:
    "Couverture d'hospitalisation annuelle : 75 000  FCFA \n Indemnité journalière d'hospitalisation : 2 500  FCFA \n Couverture décès  : 125 000 FCFA \n Formulé pour les personnes avec un faible volume d'épargne, le Pack Bronze vous permet de bénéficier d'une assurance vie à partir d'une épargne mensuelle minimal de 0 FCFA.",
  AboutSanlam: "Sanlam | Allianz",
  AboutTechCare: "TechCare 237",
  CredixDescription:
    "Credix est un fournisseur de services financiers de premier plan pour les particuliers et les entreprises en Afrique. Notre mission est de fournir un accès aux services financiers à des millions de personnes, tout en créant des emplois et en stimulant la croissance économique. Nous nous engageons à construire une communauté de clients, de partenaires et d'employés engagés qui sont passionnés par le fait de faire une différence dans la vie de nos clients.",
  SanlamDescription:
    "Issue de la fusion entre le groupe Sanlam leader panafricain de l’assurance et du groupe Allianz un des leaders mondiaux de l’assurance,SanlamAllianz est la plus large entreprise financière non bancaire.",
  SanlamDescriptionP2: "A SanlamAllianz nous protégeons les personnes pour ",
  SanlamDescriptionPointOne:
    "Faire face aux conséquences des aléas de la vie (décès, invalidité, hospitalisation…) grâce à nos produits prévoyance et",
  SanlamDescriptionPointTwo:
    "Préparer en douceur à travers l’épargne des projets importants : retraite, transmission de patrimoine, achat immobilier",
  TechCareDesc:
    "TechCare237 est une plateforme innovante qui permet aux utilisateurs de placer leur argent en toute sécurité, tout en bénéficiant d'une assurance vie. Cette solution vise à offrir une double valeur ajoutée : d'une part, elle permet aux clients de constituer une épargne facilement accessible, et d'autre part, elle leur garantit une couverture santé. Les utilisateurs de TechCare237 peuvent ainsi payer leurs soins médicaux grâce à leur épargne, tout en offrant une protection à leurs proches en cas de décès, grâce à la clause d'assurance vie incluse dans le programme.",
  TechCareDescPointOne: "Un intérêt de XX% annuel",
  TechCareDescPointTwo:
    "Une protection financière de vos proches en cas de décès, techcare 237 permet de verser un capital de 500 000 XAF au bénéficiaire désigné",
  TechCareDescPointThree:
    "Un soutien de 10 000 XAF en cas d’hospitalisation afin d’alléger les fardeaux des frais médicaux",
  ReadMore: "En savoir plus",

  // FAQ

  FAQ: "FAQ",
  claimsDeclaration: "Déclarez un sinistre",
  ifAffiled: "Vous etes deja assuré vous ne pouvez plus ajouter d'assuré.",
  notInsured: "Aucun assuré pour le moment",
  notInsuredInfo: "Veuillez ajouter un assuré pour voir les informations.",
  ClaimsDeclarationDescription:
    "En termes d'assurance, un Sinistres est tout dommage matériel ou toute blessure corporelle qui met en jeu les garanties du contrat signé par l'assureur et l'assuré. Lorsqu'une police d'assurance est souscrite, l'assuré est couvert contre divers événements inattendus, appelés \"Sinistres\". Pour les produits Techcare 237, les Sinistres comprennent le décès, l'invalidité permanente et totale et l'hospitalisation.",
  AddBeneficiary: "BÉNÉFICIAIRE",
  ifAffiled: "Vous etes deja affilié a un package d'assurance",
  assuredInsurance: "vous etes assuré",
  pendingInsurance: "Votre demande est en cours de validation .....",
  FrequentlyAskedQuestions: "Questions fréquemment posées",
  // Question1: "Déclaration de sinistre?: une demande formelle présentée au fournisseur d'assurance par le titulaire d'une police d'assurance pour obtenir l'indemnisation d'un sinistre couvert par le contrat d'assurance",
  // Question2: "Comment fonctionne l'assurance numérique ?",
  // Question3: "Quels types d'assurance sont disponibles sur votre plateforme ?",
  // Question4: "Comment puis-je acheter une assurance via votre plateforme ?",
  // Question5: "Quels sont les avantages de l'assurance numérique ?",
  // Question6: "Mes informations personnelles sont-elles sécurisées sur votre plateforme ?",
  // Question7: "Quel est le processus de Sinistres avec votre plateforme d'assurance numérique ?",
  // Question8: "Puis-je annuler ou modifier ma police d'assurance en ligne ?",
  // Question9: "Comment puis-je contacter le service client si j'ai des questions ou besoin d'aide ?",
  // Question10: "L'assurance numérique me convient-elle ?",

  Question1: "Déclaration de sinistre",
  Question1Description:
    "Une demande formelle présentée au fournisseur d'assurance par le titulaire d'une police d'assurance pour obtenir l'indemnisation d'un sinistre couvert par le contrat d'assurance.",
  Question2: "À quoi sert la clause bénéficiaire en assurance vie ?",
  Question2Description:
    "La clause bénéficiaire de votre assurance vie sert à désigner la personne qui percevra le capital lorsque surviendra votre décès. Ainsi, lors du décès de l’assuré, le capital est versé au bénéficiaire désigné dans le contrat.",
  Question3: "Accident",
  Question3Description:
    "Toute atteinte corporelle non intentionnelle résultant de l’action violente et soudaine d’une cause extérieure et indépendante de la volonté de l’Assuré.",
  Question4: "Assureur",
  Question4Description: "SANLAM LIFE INSURANCE CAMEROON.",
  Question5: "Assuré ou adhérent",
  Question5Description: "Personne sur la tête de laquelle repose l’assurance.",
  Question6: "Bénéficiaire",
  Question6Description:
    "Personne ayant vocation à percevoir les prestations prévues au contrat, en cas de réalisation du risque assuré.",
  Question7: "Capital assuré ou capital garanti",
  Question7Description:
    "Prestation due au bénéficiaire par l’Assureur à la réalisation du risque assuré.",
  Question8: "Code CIMA",
  Question8Description:
    "Code des assurances des états membres de la Conférence interafricaine des Marchés d’Assurances (CIMA).",
  Question9: "Date de consolidation",
  Question9Description:
    "Date à laquelle l'état de santé de l'assuré s'étant stabilisé, les conséquences de l'accident ou de la maladie deviennent permanentes et présumées définitives.",
  Question10: "Décès",
  Question10Description: "Cessation de la vie d’une personne.",
  Question11: "Echéance",
  Question11Description: "Date anniversaire du contrat.",
  Question12: "Nullité",
  Question12Description:
    "Sanction, de l’irrégularité d’un contrat d’assurance. La nullité anéantit rétroactivement le contrat.",
  Question13: "Prescription",
  Question13Description:
    "Délai prévu par la loi et à l’expiration duquel toute action est déclarée irrecevable.",
  Question14: "Prime",
  Question14Description:
    "Prix payé par le Souscripteur en contrepartie de la garantie offerte par l’Assureur.",
  Question15: "Résiliation",
  Question15Description:
    "Dissolution d’un contrat sur l’initiative de l’Assureur ou du Souscripteur.",
  Question16: "Souscripteur ou Contractant",
  Question16Description:
    "Personne physique ou morale ayant conclu avec l’Assureur le contrat d’assurance.",
  Question17: "Délai de carence",
  Question17Description:
    "Période de temps qui court entre la date d’effet du contrat et la date à partir de laquelle les garanties sont effectives (Il est instauré pour éviter les abus, les fraudes et responsabiliser les assurés).",

  // CONTACT US

  ContactUs: "CONTACTEZ NOUS",
  ContactForm: "Formulaire de Contact",
  Name: "Nom & Prenom",
  SurName: "Prenom",
  EnterName: "Entrez votre nom",
  EnterSurName: "Entrez votre prenom",
  Email: "Email",
  nom: "Nom",
  Message: "Message",
  EnterMessage: "Entrez votre message",
  Submit: "Soumettre",
  decesInformation: "Informations du Bénéficiaire Décès",

  //Beneficiary
  EnterBeneficiaryName: "Veuillez entrer son nom",
  EnterBeneficiarySurName: "Veuillez entrer son prénom",


  termeEtConditionsDes:
    "Termes et Conditions Générales d'Utilisation de TechCare 237",
  ClaimsDeclarationDescription:
    "En termes d'assurance, un Sinistres est tout dommage matériel ou toute blessure corporelle qui met en jeu les garanties du contrat signé par l'assureur et l'assuré. Lorsqu'une police d'assurance est souscrite, l'assuré est couvert contre divers événements inattendus, appelés \"Sinistres\". Pour les produits Techcare 237, les Sinistres comprennent le décès, l'invalidité permanente et totale et l'hospitalisation.",
  condition: "Conditions Générales",
  context: {
    title: "Contexte",
    description:
      "TechCare237 est une plateforme innovante qui permet aux utilisateurs de placer leur argent en toute sécurité, tout en bénéficiant d'une assurance vie. Cette solution vise à offrir une double valeur ajoutée : d'une part, elle permet aux clients de constituer une épargne facilement accessible, et d'autre part, elle leur garantit une couverture santé. Les utilisateurs de TechCare237 peuvent ainsi payer leurs soins médicaux grâce à leur épargne, tout en offrant une protection à leurs proches en cas de décès, grâce à la clause d’assurance vie incluse dans le programme. La plateforme est conçue pour être simple, flexible et accessible à tous, notamment aux travailleurs du secteur informel et aux petites entreprises, en intégrant les services bancaires et les opérateurs de monnaie électronique. De plus, elle respecte les normes KYC pour garantir la sécurité et la transparence des transactions, tout en répondant aux besoins croissants d'assurance et de gestion financière.",
  },
  terms: {
    1: {
      title: "Objet",
      content:
        "Les présentes conditions générales d'utilisation (ci-après « CGU ») ont pour objet de définir les modalités et conditions dans lesquelles la société CREDIXCAM S.A., société anonyme de droit camerounais, met à disposition de ses clients la plateforme d’épargne en ligne TECHCARE 237. TECHCARE 237 permet aux clients d’épargner à distance via leurs comptes Mobile Money (Orange Money ou MTN Mobile Money), dans le but d’accéder à une assurance vie couvrant l’hospitalisation et les frais funéraires, sous certaines conditions.",
    },
    2: {
      title: "Adhésion et acceptation",
      content:
        "L’inscription à la plateforme TECHCARE 237 emporte acceptation pleine et entière des présentes CGU par le client. En souscrivant, le client reconnaît avoir pris connaissance et accepté sans réserve les conditions d'utilisation du service.",
    },
    3: {
      title: "Conditions d’éligibilité",
      content:
        "Pour être éligible aux services de TECHCARE 237, le client doit : <ul><li>Être une personne physique âgée d’au moins 18 ans ;</li><li>Disposer d’un numéro de téléphone valide relié à un compte Mobile Money actif (Orange ou MTN) ;</li><li>Être résident au Cameroun ;</li><li>Effectuer une épargne régulière via la plateforme TECHCARE 237.</li></ul>",
    },
    4: {
      title: "Fonctionnement du service",
      content: {
        4.1: {
          title: "Épargne",
          content:
            "Le client épargne par le biais de son compte Mobile Money. Les fonds sont centralisés dans un compte dédié auprès d’une institution financière partenaire. <ul><li>Le montant minimum requis pour souscrire à la plateforme est fixé à 5.000 FCFA partiellement remboursable à 40%.</li><li>En cas de désinscription, les frais de clôture de 3.000 FCFA sont déduits du montant de souscription (5.000 FCFA), et le reste est restitué au client, soit 2.000 FCFA.</li><li>Pour clôturer un compte épargne, le client doit avoir fermé tous ses plans d’épargne.</li><li>Pour se désouscrire de la plateforme, le client doit d’abord fermer ses plans d’épargnes, c’est-à-dire enlever l'argent de tous ces plans d’épargne.</li><li>Deux types de plans sont disponibles : <ul><li>Épargne libre avec un taux d’intérêt de T1 %.</li><li>Épargne par objectif avec un taux d’intérêt de T2 %.</li></ul></li><li>Un client peut créer autant de plans d’épargne qu’il le souhaite.</li><li>Un plan d’épargne devient actif uniquement après un premier dépôt d’un minimum de 1.000 CFA via son compte de monnaie électronique.</li><li>Les montants d’approvisionnement des plans d’épargne sont compris entre 1.000 et 1.000.000 FCFA.</li><li>Si un client choisit l’épargne avec objectif, il doit en définir au préalable les éléments suivants : <ul><li>Un objectif d’épargne (en FCFA) à atteindre,</li><li>Un montant minimal par dépôt (1.000 FCFA minimum),</li><li>Une fréquence de dépôt (exprimée en nombre de jours).</li></ul></li></ul>",
        },
        4.2: {
          title: "Déclenchement de la couverture d’assurance",
          content:
            "Lorsque le montant épargné par le client atteint le seuil correspondant à l’un des quatre (4) paquets proposés, et qu’il est resté dans le compte pendant au moins 30 jours, le client devient éligible à une couverture d’assurance vie souscrite par CREDIXCAM S.A. auprès d’un assureur agréé.",
        },
      },
    },
    5: {
      title: "Description des paquets d’assurance",
      content:
        "<table><thead><tr><th>N°</th><th>Paquet</th><th>Épargne minimale</th><th>Prime versée par CREDIXCAM</th><th>Hospitalisation</th><th>Frais funéraires</th></tr></thead><tbody><tr><td>1</td><td>Bronze</td><td>30.000 FCFA/mois</td><td>500 FCFA/mois</td><td>75.000/an*</td><td>125.000</td></tr><tr><td>2</td><td>Silver</td><td>50.000 FCFA</td><td>800 FCFA/mois</td><td>120.000 FCFA/an*</td><td>200.000 FCFA</td></tr><tr><td>3</td><td>Gold</td><td>75.000 FCFA</td><td>1.500 FCFA/mois</td><td>225.000 FCFA/an*</td><td>375.000 FCFA</td></tr><tr><td>4</td><td>Platinium</td><td>100.000 FCFA</td><td>2.000 FCFA/mois</td><td>300.000 FCFA/an*</td><td>500.000 FCFA</td></tr></tbody></table><p>*Hospitalisation : maximum 30 jours par an, plafonné à 15 jours/mois.</p><ul><li>Tout client ayant atteint le seuil d’épargne minimum est automatiquement éligible à une police d’assurance. Pour cela, il doit souscrire à un paquet en ajoutant un bénéficiaire en cas de décès sur un de ses plans d’épargne.</li><li>Lorsque le client souscrit à un paquet d’assurance, il est bloqué sur celui-ci pour une durée d’un an.</li><li>L’utilisateur peut déclarer plusieurs sinistres dans la limite du montant de sa couverture en renseignant le numéro de contrat reçu par SMS.</li><li>Toute souscription à une assurance doit être validée par l’assureur.</li></ul>",
    },
    6: {
      title: "Durée de la couverture",
      content:
        "La couverture prend effet 30 jours après l’atteinte du seuil d’épargne et est maintenue tant que : <ul><li>Le solde du client reste supérieur ou égal au seuil du paquet choisi ;</li><li>Le client ne retire pas les fonds sous le seuil minimal ;</li><li>CREDIXCAM continue de verser la prime mensuelle chez l’assureur au nom du client.</li></ul>",
    },
    7: {
      title: "Retrait ou perte de couverture",
      content:
        "<ul><li>Aucun retrait sur l’épargne libre n’est soumis à la pénalité.</li><li>Un retrait anticipé avant d’avoir atteint l’objectif fixé sur un plan d’épargne avec objectif, entraîne une pénalité de 5%.</li><li>Tout retrait doit se faire au moins 24h après le dépôt (date de valeur), et le montant disponible doit être entièrement retiré.</li><li>Tout retrait se fait dans le compte de monnaie électronique du client.</li><li>En l'absence de retrait à l’échéance d’un Plan d’Épargne avec Objectif, celui-ci sera automatiquement requalifié en Plan d’Épargne Libre. À compter de cette requalification, les montants épargnés seront soumis au taux d’intérêt en vigueur applicable au Plan d’Épargne Libre.</li><li>Tout retrait entraînant une baisse du solde en dessous du seuil d’éligibilité à l’assurance entraîne automatiquement : <ul><li>La suspension ou la perte de la couverture d’assurance ;</li><li>L’impossibilité de bénéficier des prestations en cas de sinistre.</li></ul></li></ul>",
    },
    8: {
      title: "Rôle de CREDIXCAM",
      content:
        "CREDIXCAM agit en qualité de collecteur d’épargne et de souscripteur collectif pour l’assurance. Elle effectue, au nom et pour le compte du client, les versements mensuels de prime auprès de la compagnie d’assurance partenaire, selon les seuils atteints.",
    },
    9: {
      title: "Déclaration de sinistre",
      content:
        "En cas : <ul><li>D’hospitalisation, le client ou un proche doit transmettre les justificatifs à CREDIXCAM ou directement à l’assureur dans un délai de 7 jours ouvrables ;</li><li>De décès, les ayants droits doivent fournir un certificat de décès, une pièce d’identité valide et tout autre document exigé par l’assureur.</li></ul>",
    },
    10: {
      title: "Responsabilité",
      content:
        "CREDIXCAM S.A. ne saurait être tenue responsable : <ul><li>Du refus de prise en charge par l’assureur en cas de fausse déclaration ou dossier incomplet ;</li><li>De tout dysfonctionnement du réseau Mobile Money imputable aux opérateurs de téléphonie.</li></ul>",
    },
    11: {
      title: "Données personnelles",
      content:
        "Les données du client sont traitées conformément à la réglementation en vigueur sur la protection des données à caractère personnel. Elles sont utilisées uniquement dans le cadre de la gestion du service TECHCARE 237.",
    },
    12: {
      title: "Résiliation",
      content:
        "Le client peut à tout moment décider de se retirer de la plateforme, avec retrait de ses fonds. Toutefois, cela entraîne immédiatement l’arrêt des versements de primes d’assurance, et donc la résiliation automatique de sa couverture.",
    },
    13: {
      title: "Réclamations",
      content:
        "Toute réclamation doit être adressée au service client de CREDIXCAM par : <ul><li>E-mail : [Insérer l’e-mail]</li><li>Téléphone : [Insérer le numéro]</li><li>Ou à travers l’espace client sur la plateforme TECHCARE 237.</li></ul>",
    },
    14: {
      title: "Modification des conditions",
      content:
        "CREDIXCAM se réserve le droit de modifier à tout moment les présentes CGU. Les nouvelles conditions seront communiquées au client par tout moyen, notamment via SMS ou e-mail.",
    },
    15: {
      title: "Droit applicable et juridiction compétente",
      content:
        "Les présentes conditions sont régies par le droit camerounais. Tout litige relatif à leur interprétation ou exécution relève de la compétence exclusive des juridictions de Yaoundé, Cameroun.",
    },
  },
};

export default fr;
